import React, { useState } from 'react';
import TribunalEntry from '../components/Tribunal/TribunalEntry/TribunalEntry';

const ThreeMemberTribunal = () => {
    const [activeTab, setActiveTab] = useState(0);
    const tabs = [
        'মামলার সাধারণ তথ্য'


    ];

    // Custom styles
    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb'
        },
        header: {
            backgroundColor: '#f3f4f6',
            padding: '12px 16px',
            borderBottom: '1px solid #e5e7eb'
        },
        headerTitle: {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#1f2937',
            margin: 0
        },
        tabNav: {
            borderBottom: '1px solid #e5e7eb',
            backgroundColor: '#f9fafb',
            display: 'flex',
            overflowX: 'auto'
        },
        tabButton: {
            padding: '12px 16px',
            fontSize: '12px',
            fontWeight: '500',
            borderBottom: '2px solid transparent',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
            border: 'none',
            background: 'none',
            cursor: 'pointer'
        },
        activeTabButton: {
            borderBottomColor: '#3b82f6',
            color: '#2563eb',
            backgroundColor: 'white'
        },
        inactiveTabButton: {
            color: '#4b5563'
        },
        warningBox: {
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            padding: '12px',
            marginBottom: '16px',
            fontSize: '14px',
            color: '#b91c1c'
        },
        content: {
            backgroundColor: 'white',
            padding: '32px',
            textAlign: 'center'
        }
    };

    return (
        <div className='page-wrapper'>
            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <h1 style={styles.headerTitle}> THREE-MEMBER ARBITRAL TRIBUNAL মামলা এন্ট্রি</h1>
                </div>

                {/* <div style={styles.warningBox}>
                    (মামলার বিষয়বস্তুর সাথে সরাসরি সংশ্লিষ্ট অফিস কর্তৃক মামলা এন্ট্রি করতে হবে। মামলার রেসপন্ডেন্ট তালিকাভুক্ত হলেও বিষয়বস্তুর সাথে সংশ্লিষ্টতা না থাকলে উক্ত মামলা এন্ট্রি হতে বিরত থাকুন।)*</div> */}

                {/* Tab Navigation */}
                <div style={styles.tabNav}>
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => setActiveTab(index)}
                            style={{
                                ...styles.tabButton,
                                ...(activeTab === index ? styles.activeTabButton : styles.inactiveTabButton)
                            }}
                            onMouseOver={(e) => {
                                if (activeTab !== index) {
                                    e.target.style.color = '#1f2937';
                                    e.target.style.backgroundColor = '#f3f4f6';
                                }
                            }}
                        // onMouseOut={(e) => {
                        //     if (activeTab !== index) {
                        //         e.target.style.color = '#4b5563';
                        //         e.target.style.backgroundColor = 'transparent';
                        //     }
                        // }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* Tab Content */}
                <div style={{ padding: '16px' }}>
                    {activeTab === 0 && (
                        <div style={styles.content}>
                            {/* <AppelCaseGenralForm /> */}
                            <TribunalEntry />
                        </div>
                    )}




                </div>
            </div>
        </div>
    );
};

export default ThreeMemberTribunal;